import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

// This component checks if the user is authenticated
// If authenticated, it renders the protected component
// If not, it redirects to the login page
const AuthGuard = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // Check both session storage and local storage for authentication
    const sessionAuth = sessionStorage.getItem('isAuthenticated') === 'true';
    const localAuth = localStorage.getItem('isAuthenticated') === 'true';
    
    setIsAuthenticated(sessionAuth || localAuth);
    setIsLoading(false);
  }, []);
  
  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }
  
  // Render the protected component if authenticated
  return children;
};

export default AuthGuard;
